import Carousel, { DELAY_TIME, DOT_POSITION } from './Carousel';

export { DELAY_TIME, DOT_POSITION };
export default Carousel;
